import { render, staticRenderFns } from "./InputPesquisaCnpj.vue?vue&type=template&id=3dcb42a2"
import script from "./InputPesquisaCnpj.vue?vue&type=script&lang=js"
export * from "./InputPesquisaCnpj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports